export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6224.f5ff6735.jpg";